export default "__VITE_ASSET__f45aab3f__"